/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Selector} from "react-data-table-component";
import {VEHICLE_PROGRAMS_CONSTANTS} from "../constants";


export const t1c2Keys = ['vehicle_length', 'vehicle_height', 'vehicle_width']
const t1c1 = ['Length', 'Width', 'Height']
const t1c3 = ['Mirror to Mirror', 'Front fascia to rear fascia', 'Height of vehicle']
export const t1cols: any = [
  {name: 'Type', selector: (row: any, i: number) => t1c1[i]},
  {
    name: 'Vehicle Dimensions (mm)', selector: (row: any, i: number) => row
  },
  {name: 'Measurement Detail', selector: (row: any, i: number) => t1c3[i]},
]

export const t2cols: any = [
  {name: 'Type', selector: (row: any, i: number) => 'Height'},
  {name: 'Ground Line Non Curb (mm)', selector: (row: any, i: number) => row},
  {name: 'Measurement Detail', selector: (row: any, i: number) => ""},
]

const t4c1 = ['CG X', 'CG Y', 'CG Z']
const t4c3 = ['NX origin to x coordinate', 'NX origin to y coordinate', 'NX origin to z coordinate']

export const t4c2Keys = ['nx_origin_to_front_of_vehicle_x', 'nx_origin_to_front_of_vehicle_y', 'nx_origin_to_front_of_vehicle_z']

export const cgKeys = ['vehicle_cg_x', 'vehicle_cg_y', 'vehicle_cg_z']
const cgc1 = ['CG X', 'CG Y', 'CG Z']
const cgc3 = ['center of gravity x', 'center of gravity y', 'center of gravity z',]
export const cgCols: any = [
  {name: 'Type', selector: (row: any, i: number) => cgc1[i]},
  {name: 'Vehicle Center of Gravity (mm)', selector: (row: any, i: number) => row},
  {name: 'Measurement Detail', selector: (row: any, i: number) => cgc3[i]},
]

export const t4cols: any = [
  {name: 'Type', selector: (row: any, i: number) => t4c1[i]},
  {name: 'NX Origin to Front of Vehicle (mm)', selector: (row: any, i: number) => row},
  {name: 'Measurement Detail', selector: (row: any, i: number) => t4c3[i]},
]
export const vehicleMeasurementsKeys = 
  { 'chassis': 'Chassis', 'vehicleIntegration': 'Vehicle Integration', 'bfg':'Body, Fascia, Grill', 'exteriorTrim':'Exterior Trim' };
export const vehicleDimensionsKeyOrder: string[] = [
  'Vehicle Length',
  'Vehicle Width',
  'Vehicle Height',
  'NX Origin To Front Of Vehicle X',
  'NX Origin To Front Of Vehicle Y',
  'NX Origin To Front Of Vehicle Z',
  'P Maximum Height Z',
  'P Minimum Height Z',
  'P Nominal Height Z',
  'P Point Driver X',
  'P Point Driver Y',
  'P Point Driver Z',
  'R Maximum Height Z',
  'R Minimum Height Z',
  'R Nominal Height Z',
  'R Point Driver X',
  'R Point Driver Y',
  'R Point Driver Z',
  'Vehicle Center of Gravity X',
  'Vehicle Center of Gravity Y',
  'Vehicle Center of Gravity Z',
];

export interface VehicleMeasurementsRow {
  property_name: string
  units: string
  value: string
  details: string
}

export interface SensorPositionRow {
  propertyName: string,
  value?: string,
  units: string,
  subRows?: SensorPositionRow[],
  sensorName?: string
  sensorId: string,
  sensor_type: string
  outOfStep: string
}

interface IColumn {
  name: string
  selector: Selector<any>
}

export const updateSensorPositionsEndpoint = `${VEHICLE_PROGRAMS_CONSTANTS.itemDetails.endpoints.updateSensorPositions}`

export interface ReferenceFrame {
  xAxisTransformation: number,
  yAxisTransformation: number,
  zAxisTransformation: number
}

export const defaultReferenceFrame: ReferenceFrame = {
  xAxisTransformation: 0,
  yAxisTransformation: 0,
  zAxisTransformation: 0
}

export const axisTransformationOptions = [
  {value: 0, label: "0 deg"},
  {value: 90, label: "90 deg"},
  {value: 180, label: "180 deg"},
  {value: 270, label: "270 deg"}
]


export const COLUMN_HEADER_CONTAINED_IN_VEHICLE_PROGRAM_DEVELOPMENT_STAGE = 'Contained In Vehicle Program Development Stage'
